//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconActionOutput(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M13 19H15L12 22.5L9 19H11V10H13V19ZM22 17H16V15H20V4H4V15H8V17H2V2H22V17Z" fill="currentColor" /></svg>;
}
export default IconActionOutput;